import { districtOfficerRoleMap } from "../../config/roleConfig";
import Officers from "./Officers";

const DLCTOfficers = () => {
  return (
    <Officers
      roleIds={Object.values(districtOfficerRoleMap).map(role => role.value)}
      pageTitle="District Officers"
      district={true}
    />
  );
};

export default DLCTOfficers;
